export default {
  labels: {
    selectOne: 'Khetha inketho eyodwa',
    selectAll: 'Khetha zonke ezisebenzayo',
    typeResponse: 'Thayipha impendulo yakho ebhokisini lombhalo elingezansi.',
    recordResponse: 'Yenza ukurekhoda ukuze uphendule umbuzo.',
    enterNumeric: 'Faka impendulo enezinombolo ensimini engezansi.',
    rateResponseScale: 'Linganisela impendulo yakho esikalini esinikeziwe.',
    sliderMinimum: 'Inani elincane: {value}',
    sliderMaximum: 'Inani elikhulu: {value}',
    selectOneOptionRow: 'Khetha inketho eyodwa kulayini ngamunye.',
    selectAllOptionsRow: 'Khetha zonke izinketho ezisebenzayo kulayini ngamunye.',
    dragAndDropResponse: 'Hudula bese uphonsa izinketho ukuze uzihlele ngokuthandwa kwakho.',
    rankOrderDesktopInstruction: 'Hudula uphonse izinto ukuze uzifake esikhundleni, noma sebenzisa inkinobho ye-+ ukwengeza into. Sebenzisa izinkinobho zomcibisholo ukuphinda ulungise noma inkinobho yokususa ukuze ususe into.',
    alert: "Isixwayiso",
    error: 'Sicela ufake inombolo phakathi kuka-{min} no-{max}.',
    cameras: 'Amakhamera',
    microphones: 'Imikrofoni',
    recording: 'Ukuqopha',
    noDevicesFound: 'Awekho amadivayisi atholiwe',
    camera: 'Ikhamera',
    microphone: 'Umikrofoni',
    stopRecording: 'Misa ukuqopha',
    startRecording: 'Qala ukuqopha',
    disableCamera: 'Khubaza Ikhamera',
    enableCamera: 'Nika Amandla Ikhamera',
    disableMicrophone: 'Khubaza Umikrofoni',
    enableMicrophone: 'Nika Amandla Umikrofoni',
    settings: 'Izilungiselelo',
    recordingProgress: 'Inqobo Yokuqopha',
    playbackProgress: 'Inqobo Yokusikisela',
    play: 'Sikisela',
    pause: 'Uma Isikhashana',
    stop: 'Misa',
    record: 'Qopha',
    recordAgain: 'Qopha futhi',
    retry: 'Zama futhi',
    done: 'Qedile',
    minRecordTime: 'Sicela urekhode impendulo imizuzwana engu-{min}.',
    enlargeImage: 'Khulisa isithombe',
    enlargedImage: 'Isithombe esikhuliswe',
    close: 'Vala',
    zoomIn: 'Sondeza (zoom in)',
    zoomOut: 'Dedelana (zoom out)',
    resetZoom: 'Setha kabusha i-zoom',
    zoomLevel: 'I-zoom {percentage}%',
    imagePosition: '{current} kwangu-{total}',
    previousImage: 'Isithombe esedlule',
    nextImage: 'Isithombe esilandelayo',
    imageLoading: 'Ilayisha isithombe',
    imageLoadFailed: 'Isithombe asikwazanga ukulayishwa',
  },
  noSelection: "Akukhethiwe lutho",
  actions: {
    increase: 'Kuneza',
    decrease: 'Nciphisa'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Ukubukeza Isuvey Kuphelile',
      titleCompleted: 'Ukubukeza Isuvey Kuqedile',
      previewModeWarning: 'Leli khasi libonakala kuphela ku-Preview Mode futhi ngeke likhonjiswe kubaphenduli bangempela.',
      reachedEndPoint: 'Lolu cwaningo lufinyelele endaweni yokuphela.',
      reachedEndPointCompleted: 'Lo mbukiso ufinyelele endaweni yokuphela.',
      returnToModify: 'Buyela embuzweni odlule ukuze ushintshe izimpendulo zakho futhi uhlole indlela yocwaningo ehlukile.',
      logic: 'Ingqondo'
    }
  }
}
